import { adminApi, publicApi } from './http';

// === Admin (need login) ===

export const fetchAdminCategories = () => adminApi.get('/article-categories');

export const createAdminCategory = (payload) => adminApi.post('/article-categories', payload);

export const updateAdminCategory = (id, payload) => adminApi.put(`/article-categories/${id}`, payload);

export const deleteAdminCategory = (id) => adminApi.delete(`/article-categories/${id}`);

// === Public (no login) ===

export const fetchPublicCategories = () => publicApi.get('/article-categories');
